// extracted by mini-css-extract-plugin
module.exports = {"folderbuttonWrapper":"CreateCaseButton_folderbuttonWrapper__2xSaN","folderbutton":"CreateCaseButton_folderbutton__2182W"};